"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.MainLayout = void 0;

require("antd/lib/divider/style");

var _divider = _interopRequireDefault(require("antd/lib/divider"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _BasicLayout = require("../../../antd/layout/BasicLayout");

var _SocialAsk = require("../../../components/SocialAsk");

var _HeaderArea = require("../components/HeaderArea");

var _TravelWebwayThemeProvider = require("../../../antd/themes/TravelWebwayThemeProvider");

var _Core = require("../../../components/Core"); // import { firebaseStoreFactory } from "../data/firebaseStoreFactory";


var MainLayout =
/*#__PURE__*/
function (_React$Component) {
  (0, _inheritsLoose2.default)(MainLayout, _React$Component);

  function MainLayout(props) {
    return _React$Component.call(this, props) || this;
  }

  var _proto = MainLayout.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        siteConfig = _this$props.siteConfig;
    var siteStore = {
      siteDisplayName: siteConfig.siteTitle,
      siteHomeUrl: "/"
    };

    var header = _react.default.createElement(_HeaderArea.HeaderArea, {
      siteStore: siteStore
    });

    return _react.default.createElement(_TravelWebwayThemeProvider.TravelWebwayThemeProvider, null, _react.default.createElement(_mobxReact.Provider, {
      siteConfig: siteConfig
    }, _react.default.createElement(_BasicLayout.BasicLayout, {
      siteStore: siteStore,
      header: header
    }, children, _react.default.createElement(_Core.Box, {
      p: 3
    }, _react.default.createElement(_divider.default, null), _react.default.createElement(_SocialAsk.SocialAsk, {
      twitter: siteConfig.userTwitter
    })))));
  };

  return MainLayout;
}(_react.default.Component);

exports.MainLayout = MainLayout;